<template>
  <div class="component-modal" id="modal">
    <form class="form" v-on:submit.prevent>
      <legend>{{props ? `${$t("modal.spot_programming.client.edit")} ${props.name}` : $t("modal.spot_programming.client.create")}}</legend>
      <i class="material-icons icon" @click.stop.prevent="closeModal">close</i>
    
      <div class="component-modal__row">
        <div class="component-modal-input component-modal-input--rename">
          <input type="text" name="code" id="code" autocomplete="off" :class="{'invalid': submitted && v$.model.code.$invalid}"
            :placeholder="$t('modal.placeholder_insert') + $t('modal.spot_programming.client.code')" v-model="model.code" maxLength="10">
          <label for="code">{{$t("modal.spot_programming.client.code")}}
            <small v-if="submitted && v$.model.code.$invalid" class="pill-required">* {{ $t("modal.common.required") }}</small>
            <small v-else>*</small>
          </label>
        </div>
      </div>

      <div class="component-modal__row">
        <div class="component-modal-input component-modal-input--rename">
          <input type="text" name="name" id="name" autocomplete="off" :class="{'invalid': submitted && v$.model.name.$invalid}"
            :placeholder="$t('modal.placeholder_insert') + $t('modal.spot_programming.client.name')" v-model="model.name" maxLength="500">
          <label for="name">{{$t("modal.spot_programming.client.name")}}
            <small v-if="submitted && v$.model.name.$invalid" class="pill-required">* {{ $t("modal.common.required") }}</small>
            <small v-else>*</small>
          </label>
        </div>
      </div>

      <div class="component-modal__row component-modal__row__multiselect">
        <!-- <div class="component-modal-input component-modal-input--rename"> -->
          <label for="name">{{$t("modal.spot_programming.client.category")}}
            <small v-if="submitted && v$.model.clientCategoryId.$invalid" class="pill-required">* {{ $t("modal.common.required") }}</small>
            <small v-else>*</small>
          </label>
          <Multiselect
              v-model="model.clientCategoryId"
              :placeholder="$t('modal.placeholder_select')+$t('modal.spot_programming.client.category')"
              track-by="customLabel"
              valueProp="id"
              label="customLabel"
              :searchable="false"
              :canDeselect="false"
              :canClear="false"
              :options="clientCategories"
              :class="{'invalid': submitted && v$.model.clientCategoryId.$invalid}" />

          <!-- <select name="" id="" v-model="model.clientCategoryId" :class="{'invalid': submitted && v$.model.clientCategoryId.$invalid}">
            <option :value="null">{{$t("modal.placeholder_select")}}{{$t("modal.spot_programming.client.category")}}</option>
            <option :value="category.id" v-for="category in clientCategories" :key="category.id">{{category.code}} - {{category.name}}</option>
          </select> -->

        <!-- </div> -->
      </div>

      <div class="component-modal__row">
        <div class="component-modal-input component-modal-input--rename">
          <input type="text" name="taxCode" id="taxCode" autocomplete="off" :placeholder="$t('modal.placeholder_insert') + $t('modal.spot_programming.client.taxCode')" v-model="model.taxCode">
          <label for="taxCode">{{$t("modal.spot_programming.client.taxCode")}}</label>
        </div>
      </div>

      <div class="component-modal__row">
        <div class="component-modal-input component-modal-input--rename">
          <input type="text" name="address" id="address" autocomplete="off" :placeholder="$t('modal.placeholder_insert') + $t('modal.spot_programming.client.address')" v-model="model.address">
          <label for="address">{{$t("modal.spot_programming.client.address")}}</label>
        </div>
      </div>

      <div class="component-modal__row">
        <div class="component-modal-input component-modal-input--rename">
          <input type="text" name="phone" id="phone" autocomplete="off" :placeholder="$t('modal.placeholder_insert') + $t('modal.spot_programming.client.phone')" v-model="model.phone">
          <label for="phone">{{$t("modal.spot_programming.client.phone")}}</label>
        </div>
      </div>

      <div class="component-modal__row">
        <div class="component-modal-input component-modal-input--rename">
          <input type="text" name="contact" id="contact" autocomplete="off" :placeholder="$t('modal.placeholder_insert') + $t('modal.spot_programming.client.contact')" v-model="model.contact">
          <label for="contact">{{$t("modal.spot_programming.client.contact")}}</label>
        </div>
      </div>

      <div class="component-modal__row">
        <div class="component-modal-input component-modal-input--rename">
          <input type="text" name="email" id="email" autocomplete="off" :placeholder="$t('modal.placeholder_insert') + $t('modal.spot_programming.client.email')" v-model="model.email">
          <label for="email">{{$t("modal.spot_programming.client.email")}}</label>
        </div>
      </div>

      <div class="component-modal__row">
        <div class="component-modal-input component-modal-input--rename">
          <input type="text" name="comments" id="comments" autocomplete="off" :placeholder="$t('modal.placeholder_insert') + $t('modal.spot_programming.client.comments')" v-model="model.comments">
          <label for="comments">{{$t("modal.spot_programming.client.comments")}}</label>
        </div>
      </div>
    
      <div class="component-modal__row">
        <button type="button" @click.stop.prevent="saveAndClose">
          {{ props ? $t("modal.save") : $t('modal.create') }}
        </button>
        <button type="button" class="button-cancel" @click.stop.prevent="closeModal">
          {{ $t("modal.cancel") }}
        </button>
      </div>

      <div class="component-modal__row" v-if="submitted && v$.model.$invalid">
        <div class="modal__form-error">
          <i class="material-icons">info_outline</i>
          <span v-html="$t('modal.common.required_message', {inputs : v$.model.$silentErrors.map(error => $t(`modal.spot_programming.client.${error.$property == 'clientCategoryId' ? 'category' : error.$property}`)).join(', ') })"></span>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { computed, onMounted, ref } from '@vue/runtime-core';
import { useStore } from 'vuex';
import { maxLength, required } from '@vuelidate/validators';
import useVuelidate from '@vuelidate/core';
import Multiselect from '@vueform/multiselect';

export default {
  components: {
    Multiselect
  },
  setup() {
		const v$ = useVuelidate();
    const store = useStore();
    const props = computed(() => store.getters.modal_getProps);
    const clientCategories = computed(() => store.getters.clientCategory_categoriesList);
    const submitted = ref(false);
    const model = ref({
      code: '',
      name: '',
      clientCategoryId: null,
      taxCode: '',
      address: '',
      phone: '',
      contact: '',
      email: '',
      comments: ''
    })

    onMounted(async () => {
      if (props.value) model.value = Object.assign({}, props.value);
    })

    async function closeModal() {
      await store.dispatch('modal_setActive');
      submitted.value = false;
    }

    async function saveAndClose() {
      submitted.value = true;
      if (!v$.value.model.$invalid) {
        try {
          await store.dispatch(props.value ? 'client_update' : 'client_create', model.value);
          this.closeModal();
        } catch (error) {
          console.error(error);
        }
      }
    }

    return {
      v$,
      props,
      model,
      clientCategories,
      submitted,
      saveAndClose,
      closeModal
    }
  },
	validations () {
    return {
      model: {
				code: {required, maxLengthValue: maxLength(10)},
				name: {required, maxLengthValue: maxLength(500)},
        clientCategoryId: {required}
			}
    }
  }
};
</script>